/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '../index';

/**
 * @param {string} brand - from store; "1800flowers"
 * @param {string} title (optional) - title of wrap_up_products entry in CMS
 */
const findWrapUpsAndContent = (brand, title = 'Default') => (
    gql` query findWrapUpsAndContent {
        findWrapUpsAndContent (
            brand: "${brand['domain-name']}",
            environment: "${GRAPHQL_ENV}",
            key: "${title}"
        ) {
            content
            wrapUps {
                skuPartNumber
                additionalCopy
                infoOnHover
                uid
                sku {
                    brandId
                    name
                    image {
                        name
                        path
                    }
                    id
                    prices {
                        type
                        value
                    }
                    parentProduct {
                        partNumber
                        categories
                        image {
                            path
                            name
                        }
                    }
                    availability {
                        availabilityIndicator
                        published
                    }
                },
                uid
            }
        }
    }`
);

export default findWrapUpsAndContent;
